import React, { useState, useEffect } from "react";
import { Container, Button, Dropdown } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { FaUserCircle } from "react-icons/fa";
import api from '../api/axiosInstance';
import "../styles/custom.scss";

const AppNavbar = () => {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);

  // Scroll efekti
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Kullanıcı bilgisi çek
  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token);

    if (token) {
      api
        .get("/auth/me", {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          setUser(res.data);
          localStorage.setItem("user", JSON.stringify(res.data)); // ⬅ EKLENDİ
        })
        .catch(() => {
          setUser(null);
          localStorage.removeItem("user");
        });
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/");
    window.location.reload();
  };

  return (
    <nav
      className={`navbar navbar-expand-lg fixed-top ${
        scrolled ? "navbar-glass" : "navbar-transparent"
      }`}
    >
      <Container>
        <Link className="navbar-brand fw-bold d-flex align-items-center" to="/">
          <img
            src="/logo512.png"
            alt="Majistral App Logo"
            width="40"
            height="40"
            className="me-2"
          />
          Majistral App
        </Link>

        <div className="d-flex align-items-center">

          {/* 🟩 Veri Tabanı (Ödeme yapılmış kullanıcılar) */}
          {isLoggedIn && user?.isApproved && (
            <Button
              as={Link}
              to="/panel"
              variant="success"
              className="me-3 fw-bold"
              style={{ borderRadius: "50px" }}
            >
              Veri Tabanı
            </Button>
          )}

          {/* 🟨 Ödeme Yap (henüz onaylanmamışlar) */}
          {isLoggedIn && user && !user.isApproved && (
            <Button
              as={Link}
              to="/odeme"
              variant="warning"
              className="me-3 fw-bold"
              style={{ borderRadius: "50px", color: "#000" }}
            >
              Ödeme
            </Button>
          )}

          {/* Giriş yapmamış kullanıcılar */}
          {!isLoggedIn && (
            <>
              <Button as={Link} to="/login" variant="outline-primary" className="me-2">
                Giriş
              </Button>
              <Button as={Link} to="/register" variant="primary">
                Üye Ol
              </Button>
            </>
          )}

          {/* 🔻 Kullanıcı Menü Dropdown */}
          {isLoggedIn && (
            <Dropdown align="end">
              <Dropdown.Toggle
                variant="outline-primary"
                id="user-menu"
                className="d-flex align-items-center"
                style={{ borderRadius: "50px" }}
              >
                <FaUserCircle size={22} className="me-1" />
              </Dropdown.Toggle>

              <Dropdown.Menu>

                {/* 🔥 Admin Paneli (sadece admin görecek) */}
                {user?.role === "admin" && (
                  <Dropdown.Item
                    as={Link}
                    to="/admin"
                    className="fw-bold text-danger"
                  >
                    Admin Paneli
                  </Dropdown.Item>
                )}

                <Dropdown.Item as={Link} to="/profil">
                  Bilgilerimi Görüntüle
                </Dropdown.Item>

                <Dropdown.Divider />

                <Dropdown.Item onClick={handleLogout} className="logout-item">
                  Çıkış Yap
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}
        </div>
      </Container>
    </nav>
  );
};

export default AppNavbar;
